import { ApiClient } from "../ApiClient";

/**
 * Fetch the review list for a specific filing (Authenticated)
 * @param {string} url - The dynamic endpoint path
 * @param {string|number} filingId - The filing identifier
 * @returns {Promise<Response>}
 */
export const fetchFilingReviewList = async (url, filingId) => {
  // ApiClient.get handles baseUrl and credentials automatically
  return ApiClient.get(`${url}/${filingId}`);
};

/**
 * Create a new filing review
 * @param {string} url - The dynamic endpoint path
 * @param {Object} queryData - The review data payload
 * @returns {Promise<Response>}
 */
export const createFilingReview = async (url, queryData) => {
  // ApiClient.post handles baseUrl, CSRF, and JSON stringification
  return ApiClient.post(url, queryData);
};

/**
 * Fetch a list of public filing reviews (No specific credentials required)
 * @param {string} url - The dynamic endpoint path
 * @returns {Promise<Response>}
 */
export const fetchPublicFilingReviewList = async (url) => {
  // Even for public requests, ApiClient handles the baseUrl and headers.
  // Since get() defaults to requiresCsrf = false, this is safe for public endpoints.
  return ApiClient.get(url);
};
